// extracted by mini-css-extract-plugin
module.exports = {"chatBubble":"LiveAgent_chatBubble__LtEYJ","wrapper":"LiveAgent_wrapper__qfhSE","title":"LiveAgent_title___YHVi","content":"LiveAgent_content__YWb4S"};